import { ResponseCenterParams } from "../../core/api/responsecenters/types";
import {
  ITreeData,
  CustomDropdown,
} from "../../ui-lib/components/Hierarchy/CustomTreeDropdown/CustomDropdown";

type OrganizationSettings = Pick<ResponseCenterParams, "organizationId">;

const CustomerPicker = ({
  settings,
  setSettings,
  organizationId,
  organizationsById,
}: {
  settings: OrganizationSettings;
  setSettings: (settings: OrganizationSettings) => void;
  organizationId?: number;
  organizationsById?: ITreeData | null;
}) => {
  const orgTree: ITreeData[] = organizationsById?.children || [];

  return (
    <CustomDropdown
      parentId={organizationId?.toString()}
      customerFilter={{ customers: settings.organizationId?.toString() }}
      onSelect={(selectedItem) => {
        if (!selectedItem) {
          setSettings({
            organizationId: undefined,
          });

          return;
        }
        setSettings({
          organizationId: +selectedItem,
        });
      }}
      disabled={!!organizationId && !orgTree.length}
      selectionMode="single"
    />
  );
};

export default CustomerPicker;
